var _circle, _path, _circle2, _ellipse, _circle3, _line, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractGroupHero2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 145,
    viewBox: "0 0 140 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.95,
    cy: 56.0328,
    r: 2.03891,
    transform: "rotate(-152.205 124.95 56.0328)",
    fill: "white",
    stroke: "#4D4ABF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5253 5.75037L106.364 21.8567M107.855 22.6429L126.295 56.7414L77.0548 23.6498",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.149,
    cy: 21.6452,
    r: 3.41878,
    transform: "rotate(-152.205 106.149 21.6452)",
    fill: "#4D4ABF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.3607,
    cy: 22.9258,
    rx: 4.36843,
    ry: 4.1785,
    transform: "rotate(-152.205 77.3607 22.9258)",
    fill: "#4D4ABF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3711,
    cy: 5.79905,
    r: 1.51409,
    transform: "rotate(-142.165 73.3711 5.79905)",
    fill: "#4D4ABF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35.0057,
    y1: 129.454,
    x2: 8.26676,
    y2: 106.412,
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1002,
    cy: 131.796,
    r: 3.22595,
    transform: "rotate(-119.36 38.1002 131.796)",
    fill: "white",
    stroke: "#4D4ABF",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.41041,
    cy: 106.365,
    r: 5.68317,
    transform: "rotate(-119.36 8.41041 106.365)",
    fill: "#4D4ABF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractGroupHero2);
export default __webpack_public_path__ + "static/media/contract-group-hero2.990854cfd26060e176d5220d84eb5c3f.svg";
export { ForwardRef as ReactComponent };